import { useMemo } from 'react';
import { defaultBreakpointsDetails } from './defaultConfig';
import { useMediaQuery } from './useMediaQuery';
import { getBreakpointsDetails } from './utils/getBreakpointsDetails';
/**
 * Use breakpoint
 *
 * A hook used to get the current media query breakpoint
 *
 * @example
 *   const breakpoint = useBreakpoint();
 *   console.log(breakpoint); // eg. 'sm'
 *
 *   const breakpointWithSRRFallback = useBreakpoint({ fallback: 'lg' });
 *
 *   const breakpointWithCustomBreakpoints = useBreakpoints({
 *     breakpoints: { sm: '400px' },
 *   });
 *
 *   console.log(breakpointWithCustomBreakpoints); // 'base' || 'sm'
 */
export function useBreakpoint(arg) {
    var _a, _b;
    const { breakpoints, fallback } = arg !== null && arg !== void 0 ? arg : {};
    const breakpointDetails = useMemo(() => {
        if (!breakpoints) {
            return defaultBreakpointsDetails;
        }
        return getBreakpointsDetails(breakpoints);
    }, [breakpoints]);
    const mediaQueries = useMemo(() => {
        return breakpointDetails.breakpoints.map((breakpointDetail) => breakpointDetail.minMaxQuery);
    }, [breakpointDetails]);
    const fallbackValues = useMemo(() => {
        return breakpointDetails.breakpoints.map((breakpointDetail) => breakpointDetail.breakpoint === fallback);
    }, [breakpointDetails, fallback]);
    const currentMediaQueryValues = useMediaQuery(mediaQueries, {
        fallback: fallbackValues,
    });
    const currentMediaQueryIndex = currentMediaQueryValues.findIndex((mediaQuery) => !!mediaQuery);
    return ((_b = (_a = breakpointDetails.breakpoints[currentMediaQueryIndex]) === null || _a === void 0 ? void 0 : _a.breakpoint) !== null && _b !== void 0 ? _b : fallback);
}
